window.WMDA_SDK_CONFIG = {
  api_v: 1,
  sdk_v: 0.1,
  mode: 'report',
  appid: 27059861252535,
  key: 'e5h9si7t',
  project_id: '19481878409907',
  cookie_domain: document.domain,
  cate_id: '',
  page_extra: [
    {
      key: '',
      value: ''
    }
  ],
  user_extra: [
    {
      key: '',
      value: ''
    }
  ],
  channel: '',
  SPA_HASH: true,
  getUserId: function() { }
}

const wmda = document.createElement('script')
wmda.type = 'text/javascript'
wmda.async = true
wmda.crossOrigin = 'anonymous'
wmda.src =
    (document.location.protocol === 'https:' ? 'https://' : 'http://') +
    'j1.58cdn.com.cn/wmda/js/statistic.js'
const s = document.getElementsByTagName('script')[0]
s.parentNode.insertBefore(wmda, s)



// WEBPACK FOOTER //
// ./src/utils/wmda.js